export interface User {
  createdAt: number;
  email: string;
  family_name: string;
  given_name: string;
  org: string;
  role: number;
  status?: UserStatus;
  sub: string;
  _id: string;
}

export const ValidUserStatuses = ['active', 'inactive', 'invited', undefined] as const;
export type UserStatus = (typeof ValidUserStatuses)[number];
